import { useBreakpointValue } from '@chakra-ui/react'
import React, { useState } from 'react'
import OtpDesktop from './otp.desktop'
import OtpMobile from './otp.mobile'
import customerService from '@/app/[locale]/_service/customer.service'
import { IRedux } from '@/app/[locale]/_store/types'
import { useSelector } from 'react-redux'
import { track } from '@/app/[locale]/_utils/utm'

interface IProps {
  isRegister: boolean
  phoneNumber: string
  backToLogin: () => void
  onSuccess: (data: any) => void
}

const Auth = ({ isRegister, phoneNumber, backToLogin, onSuccess }: IProps) => {
  const [isError, setError] = useState(false)
  const [isSuccess, setSuccess] = useState(false)

  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  const { fcm_token, platform_id } = useSelector(
    (state: IRedux) => state.session
  )

  const trackRegister = async ({ customer_id }: Record<string, string>) => {
    try {
      await track({
        action_type: 'register',
        customer_id,
        tg_chat_id: "",
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onSubmit = async (code: string) => {
    try {
      if (isError) setError(false)

      const data: {
        code: string
        phone: string
        tg_chat_id?: string
        fcm_token?: string
      } = {
        code,
        phone: phoneNumber,
      }

      if (fcm_token) data['fcm_token'] = fcm_token

      const response = await customerService[
        isRegister ? 'registerConfirm' : 'loginConfirm'
      ](data, platform_id)

      setSuccess(true)
      if (isRegister) await trackRegister({ customer_id: response?.data?.id })

      setTimeout(() => {
        onSuccess(response?.data)
      }, 1000)
    } catch (error) {
      setError(true)
    }
  }

  return (
    <>
      {isDesktop ? (
        <OtpDesktop
          isError={isError}
          onSubmit={onSubmit}
          isSuccess={isSuccess}
          phoneNumber={phoneNumber}
          backToLogin={backToLogin}
        />
      ) : (
        <OtpMobile
          isError={isError}
          onSubmit={onSubmit}
          isSuccess={isSuccess}
          phoneNumber={phoneNumber}
          backToLogin={backToLogin}
        />
      )}
    </>
  )
}

export default Auth
